module.exports = __webpack_public_path__ + "static/media/background.fa797e73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background.jpg
// module id = 992
// module chunks = 0